













import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import AbpBase from '../../lib/abpbase'
import myTable from '../../components/table/my-table.vue'
import {GetMedicationInfo} from '../../api/realTime'
@Component({
    components: {myTable}
})
export default class extends AbpBase {
    @Prop({type:Number}) id:any;
    created(){
        this.getData()
    }
    get height(){
        return window.innerHeight-220
    }
    async getData(){
        let res = await GetMedicationInfo({patientId:this.id})
        this.list = res.data
    }
    detailShow = false
    detailData = {}
    list = []
    columns = [
        {title:'药品类型',key:'drugType'},
        {title:'药品名称',key:'drugName'},
        {title:'用药方式',key:'useage'},
        {title:'用药频次',key:'frequencyTimes'},
        {title:'备注',key:'remark',width:600},
        {title:'开始时间',key:'startDate'},
        {title:'结束时间',key:'endDate'},
        {title:'状态',key:'status'},
    ]
}
